import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-132d6353"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Ok")
const _hoisted_2 = {
  key: 0,
  class: "break-line ion-padding-top"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Itt fognak megjelenni azok, ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" akiket meghívtál a rendezvényre ")
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "break-line ion-padding-top"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Éppen keresel, ezért csak azokat")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" fogod látni, akik megfelelnek a keresésnek. ")
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Többiek")
const _hoisted_14 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_item_group = _resolveComponent("ion-item-group")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createBlock(_component_ion_modal, {
    "is-open": _ctx.inviteFriendsModal.open,
    "swipe-to-close": true,
    "show-backdrop": true,
    "presenting-element": 
            _ctx.inviteFriendsModal.partyJoinModalRef?.$el ||
            _ctx.$root.$refs.mainRouterOutlet.$el
        ,
    onDidDismiss: _ctx.dismiss
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_searchbar, {
                animated: "",
                debounce: "100",
                modelValue: _ctx.query,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
                placeholder: "Keresés"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.dismiss }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item_divider, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "list-group-label" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.friendsInvited.length == 0 && _ctx.query == ""
                                    ? "Még nem hívtál meg senkit"
                                    : "Meghívottak") + " ", 1),
                          (_ctx.friendsInvited.length == 0 && _ctx.query == '')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _hoisted_6))
                            : _createCommentVNode("", true),
                          (_ctx.friendsInvited.length == 0 && _ctx.query != '')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _hoisted_11))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.friendsInvited, (friend) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: friend.id,
                      onClick: ($event: any) => (_ctx.uninvite(friend))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_avatar, { slot: "start" }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: 
                                    './assets/image/avatars/' +
                                    friend.username +
                                    '.jpg'
                                
                            }, null, 8, _hoisted_12)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(friend.firstName + " " + friend.lastName), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_checkbox, {
                          slot: "end",
                          checked: true
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item_divider, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { class: "list-group-label" }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.friendsNotInvited, (friend) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: friend.id,
                      onClick: ($event: any) => (_ctx.invite(friend))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_avatar, { slot: "start" }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: 
                                    './assets/image/avatars/' +
                                    friend.username +
                                    '.jpg'
                                
                            }, null, 8, _hoisted_14)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(friend.firstName + " " + friend.lastName), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_checkbox, {
                          slot: "end",
                          checked: false
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, {
                class: "scrollfix",
                lines: "none"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open", "presenting-element", "onDidDismiss"]))
}